<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-menu *ngIf="!simplePage" contentId="main-content" type="overlay">
      <ion-content>
        <app-lateral-menu></app-lateral-menu>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>

  <!-- 🔥 COMPONENTE GLOBAL PARA LLAMADAS SIP - Solo para usuarios con rol operator -->
  <app-global-sip-call *ngIf="isOperator"></app-global-sip-call>
</ion-app>